/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { db_DropdownSupportRequestStatus } from '../models/db_DropdownSupportRequestStatus';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class SupportRequestStatuses {
    /**
     * Get a list of support request statuses
     * @returns db_DropdownSupportRequestStatus OK
     * @throws ApiError
     */
    public static listSupportRequestStatuses(): CancelablePromise<Array<db_DropdownSupportRequestStatus>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/support-request-statuses',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                500: `Internal Server Error`,
            },
        });
    }
}
